import { mediaQuery } from 'constants/ui';

export const filterBarStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  position: 'sticky',
  top: 0,
  backgroundColor: ({ palette }) => palette.background.paper,
  paddingBottom: '4px',
  zIndex: 1,
};

export const filterTopRowStyles = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  flexWrap: 'wrap',
};

export const filterFieldStyles = {
  minWidth: 220,
  flex: '1 1 220px',

  [mediaQuery.mobileAndTablet]: {
    minWidth: 0,
    flex: '1 1 100%',
  },
};

export const chipRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
};

export const statusGroupStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
};

export const savedChipRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
};

export const groupByToggleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginLeft: 'auto',
};

export const groupSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const groupHeaderStyles = {
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  paddingBottom: '4px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
};

export const groupTitleStyles = {
  color: ({ palette }) => palette.text.strong,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
};

export const groupMetaStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const rowsListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const paginationRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: '8px',
  borderTop: ({ palette }) => `1px solid ${palette.border.light}`,
};

export const pagerButtonsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
